import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Divider,
  Grid,
  useTheme,
  Icon,
} from '@mui/material';
import { PasswordChangeForm } from '../../auth/components/PasswordChangeForm';

export const Settings: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight="500">
        Settings
      </Typography>

      <Grid container spacing={3}>
        {/* Security Section */}
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={0}
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: theme.palette.background.paper,
              borderRadius: 2,
            }}
          >
            <Box display="flex" alignItems="center" gap={1} mb={3}>
              <Icon style={{ color: theme.palette.primary.main }}>security</Icon>
              <Typography variant="h6" fontWeight="500">
                Security Settings
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />
            <PasswordChangeForm />
          </Paper>
        </Grid>

        {/* Other settings sections can be added here */}
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={0}
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: theme.palette.background.paper,
              borderRadius: 2,
            }}
          >
            <Box display="flex" alignItems="center" gap={1} mb={3}>
              <Icon style={{ color: theme.palette.primary.main }}>settings</Icon>
              <Typography variant="h6" fontWeight="500">
                General Settings
              </Typography>
            </Box>
            <Divider sx={{ mb: 3 }} />
            <Typography color="textSecondary">
              Additional settings can be configured here.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
